import { createMyPluginFactory } from '../../plateFunctions';
import { ELEMENT_HTML } from '../../plateTypes';
import { makeNodeId } from '../../utils/nodeId';

export const createHtmlPlugin = createMyPluginFactory({
  key: ELEMENT_HTML,
  isElement: true,
  isVoid: true,
  deserializeHtml: {
    // NOTE: this will be replaced when the table plugin is implemented
    rules: [{ validNodeName: ['TABLE'] }],
    getNode(el) {
      const html = el.outerHTML;
      return {
        type: ELEMENT_HTML,
        id: makeNodeId(),
        html,
      };
    },
  },
});
